// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Uloc from './uloc'
import App from './Root.vue'
import router from './router'
import store from './store'
import ProgressBar from './app/_default/components/ProgressBar.vue'
import LoadOverlay from './app/_default/components/LoadOverlay.vue'
import {number_format as numberFormat} from './utils/helpers/phpjs'
import VueHighcharts from 'vue-highcharts'
import {UButton, UButtonGroup, UButtonGroupItem} from './app/_default/components/Uloc/button'
import UFakeLoader from './app/_default/components/Uloc/FakeLoader.vue'
import UConfirm from './app/_default/components/Uloc/Confirm.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// Uloc Global Components
Vue.component(UButton.name, UButton)
Vue.component(UButtonGroup.name, UButtonGroup)
Vue.component(UButtonGroupItem.name, UButtonGroupItem)
Vue.component(UFakeLoader.name, UFakeLoader)
Vue.component('v-select', vSelect)
// Vue.component(UConfirm.name, UConfirm)
const uconfirm = Vue.prototype.$confirm = new Vue(UConfirm).$mount()
document.body.appendChild(uconfirm.$el)

window.responseError = function (response) {
  if (typeof response.data.errors === 'undefined') {
    console.log('Ocorreu um erro cuja variável response.data.errors é undefined', response)
    return
  }
  window.alert('Erro ao efetuar a operação: \n\n' + response.data.errors)
}

Vue.use(VueHighcharts)

Vue.use(Uloc)

var moment = require('moment')

// TODO: separar isto até chegar no Vue.config.produ...
moment.locale('pt-br')
Vue.mixin({
  filters: {
    moment: function (date) {
      if (date === null) return
      return moment(date).fromNow()
    },
    moeda: function (valor) {
      return numberFormat(valor, 2, ',', '.')
    },
    number: function (valor) {
      return numberFormat(valor, null, ',', '.')
    },
    formataCpf: function (cpf) {
      return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/g, '$1.$2.$3-$4')
    },
    formataCnpj (cnpj) {
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
    },
    formataCep (cep) {
      cep = '' + cep
      return cep.trim().replace(/(\d{2})(\d{3})(\d{3})/g, '$1.$2-$3')
    },
    formataTelefone (telefone) {
      if (typeof telefone === 'undefined') {
        return
      }
      return telefone.length === 11 ? telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') : telefone.length === 10 ? telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3') : null
    },
    formatDate: function (date, format) {
      if (date === null) return
      return moment(date).format(format)
    }
  },
  methods: {
    moment: function (date) {
      if (date === null) return
      return moment(date)
    }
  }
})

// material
// import VueMaterial from 'vue-material'
//
// Vue.use(VueMaterial)
// Vue.use(VueMaterial.mdCore)
// Vue.use(VueMaterial.mdDialog)

// global progress bar
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

// global load overlay
const loaderOverlay = Vue.prototype.$loaderOverlay = new Vue(LoadOverlay).$mount()
document.body.appendChild(loaderOverlay.$el)

import Shortkey from './utils/directives/shortkey.js'
Vue.use(Shortkey, { prevent: ['input', 'textarea', '.no-shortkey'] })

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  name: 'uloc',
  router,
  store,
  render: h => h(App)
  // template: '<App/>',
  // components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js